import React, { PureComponent, Fragment } from 'react'
import { connect } from 'react-redux'
import Slider from 'rc-slider'
import 'rc-slider/assets/index.css'
import LayerActions from '../redux/layerRedux'
import { makeGetTransparency } from '../selectors/transparencySelector'
import Tooltip from 'rc-tooltip'
import '../assets/styles/rc-slider.css'
import Typography from '@material-ui/core/Typography'

const SliderTooltip = Slider.createSliderWithTooltip(Slider)

class SliderTransparency extends PureComponent {
  static defaultProps = {
    layerName: '',
    min: 0,
    max: 100,
    value: 100
  }

  handleChange = value => {
    const { actions, layerName, layerOpacity } = this.props
    actions.layerTransparencyUpdated(layerName, layerOpacity, value > 0 ? value / 100 : 0.01)
  }

  render () {
    const { transparency, label='Transparency', marks={} } = this.props

    return (
      <Fragment>
        <div style={{ display: 'block', width: '100%' }} >
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography key='title'>{label}</Typography>
            <Typography key='value'>{`${(transparency*100).toFixed(0)}%`}</Typography>
          </div>
          <SliderTooltip
            key='slider'
            onChange={this.handleChange}
            value={transparency * 100}
            marks={marks}
            tipFormatter={value => `${value}% transparency`}
            tipProps={{ style:{ zIndex: 9999, color: 'red' }}} />
        </div>
      </Fragment>
    )
  }
}

const makeMapStateToProps = () => {
  const getTransparency = makeGetTransparency()
  const mapStateToProps = (state, props) => {
    return {
      transparency: getTransparency(state, props.layerName) || 1
    }
  }
  return mapStateToProps
}

const mapPropsToState = dispatch => {
  return {
    actions: {
      layerTransparencyUpdated: (layerName, layerOpacity, transparency) =>
        dispatch(
          LayerActions.layerTransparencyUpdated(
            layerName,
            layerOpacity,
            transparency
          )
        )
    }
  }
}

export default connect(makeMapStateToProps(), mapPropsToState)(
  SliderTransparency
)



// WEBPACK FOOTER //
// ./src/components/SliderTransparency.js